export default {
  addressBook: {
    cancel: 'Cancel',
    row: {
      actions: {
        change: 'Change',
      },
    },
    listView: {
      header: 'Choose Shipping Address',
      submit: 'Use Address',
    },
    createView: {
      header: 'Add a New Shipping Address',
      submit: 'Save & Use Address',
    },
    editView: {
      header: 'Edit Shipping Address',
      submit: 'Save & Use Address',
    },
  },
  cart: {
    startCheckout: 'Proceed to Checkout',
    guestUserAuthModalText: "Don't have an account?",
    guestUserAuthModalButtonText: 'Continue as Guest',
  },
  checkoutProgressBar: {
    shipping: 'Shipping',
    payment: 'Payment',
    confirmation: 'Confirmation',
  },
  loadingIndicator: {
    oneMomentPlease: 'One moment please',
  },
  orderSummary: {
    cannotBeShippedToAddress: 'Sorry, this listing is not available to ship to your location.',
    messageSeller: 'Message Seller',
    soldBy: 'Sold by {{shopName}}',
    shipsFrom: 'Ships from {{location}}',
    shippingCost: '{{amount}} Shipping',
    title: 'Order Summary',
  },
  klarnaPaymentTerms: {
    ca: 'View the Privacy Notice and Klarna Shopping Service terms {{linkOpen}}here.{{linkClose}}.',
    es: 'Please note that a higher initial payment may be required for some purchases. More information in the Pay later over 3 installments complete {{linkOpen}}terms{{linkClose}}.',
    fr: 'Pay later in 3 installments {{linkOpen}}complete terms{{linkClose}}.',
    gb: 'You must be 18+ to use this credit offer. Klarna uses soft searches with credit reference agencies. These do not affect your credit rating. Missed payments can affect your ability to use Klarna. Pay in 3 complete {{linkOpen}}terms{{linkClose}}.',
    it: 'Please note that a higher initial payment may be required for some purchases. More information in the Pay later over 3 installments complete {{linkOpen}}terms{{linkClose}}.',
  },
  orderQuantitySelector: {
    label: 'Quantity',
  },
  orderShippingMethodSelector: {
    label: 'Shipping Method',
  },
  paymentLayout: {
    continueOnKlarna: 'Continue on Klarna',
    changeShippingAddress: 'Change',
  },
  paymentMethod: {
    title: 'Payment Method',
    affirm: {
      nextStep: 'You will be redirected to Affirm to set up your payment.',
      availabilityDisclaimer: 'Affirm payments are not available to residents of Iowa and West Virginia',
    },
  },
  redirectReturnLayout: {
    paymentProcessing: 'Processing...',
  },
  paymentInProgressLayout: {
    title: {
      paymentInProgress: 'Placing your order...',
      paymentProcessing: 'Processing...',
    },
  },
  shippingAddress: 'Shipping Address',
  shippingLayout: {
    continueToPayment: 'Continue',
  },
  creditCardCreateForm: {
    editButton: 'Edit',
    cancelEditButton: 'Cancel',
  },
  creditCardSaveButton: {
    default: 'Save Changes',
    saving: 'Saving...',
  },
  newShippingAddressForm: {
    contactInfo: {
      title: 'Contact Info',
      firstNameLabel: 'First name',
      lastNameLabel: 'Last name',
      emailLabel: 'Email',
    },
    address: {
      tooltip: 'Add your phone number to stay informed about your package.',
      phoneLabelText: 'Phone Number',
    },
    saveButton: {
      default: 'Save Changes',
      saving: 'Saving...',
    },
  },
  billingAddress: 'Billing Address',
  billingAddressForm: {
    address: {
      tooltip: 'Add your phone number to stay informed about your package.',
      phoneLabelText: 'Phone Number',
    },
    saveButton: {
      default: 'Save Changes',
      saving: 'Saving...',
    },
  },
  buyItNow: {
    title: 'Buy It Now',
    error: 'Something went wrong. Please try again.',
    applePay: 'Apple Pay',
    notInSameCountry: 'This item is shipping to you from {{sellerCountry}}. You may be required to pay import duties or taxes upon delivery.',
  },
  errors: {
    standardUserExists: 'You already have an account on Reverb. Please log in to complete this order.',
  },
  checkoutLayout: {
    saveAddress: 'Save Address',
    addressSaved: 'Saved',
    placeOrder: 'Place Order',
  },
  creditCardWallet: {
    modalButtonChange: 'Change',
    modalButtonSelect: 'Select a card',
  },
  changePaymentMethod: {
    direct_checkout: {
      message: "Don't want to use a card? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    klarna_account: {
      message: "Don't want to use Klarna? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    sofort: {
      message: "Don't want to use Sofort? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
    affirm: {
      message: "Don't want to use Affirm? {{children}} and choose a different payment method.",
      link: 'Go back to cart',
    },
  },
  confirmationPage: {
    claimOrderBannerText: 'This email address is associated with an existing Reverb account',
    claimOrderButtonText: 'Sign In to Save Order',
  },
  sofortContinueButton: {
    buttonText: 'Continue on Sofort',
  },
  affirmContinueButton: {
    text: {
      default: 'Check Out with Affirm',
      loading: 'Please wait...',
    },
  },
};
